import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 3C7A28AA-E21B-4DCC-B6DF-4EBEF2A93C01
 * name invoice-list
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-list.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceListIcon = createSvgIcon(<><path d="M3 22V3H21V22L18 20L15 22L12 20L9 22L6 20L3 22M17 9V7H15V9H17M13 9V7H7V9H13M13 11H7V13H13V11M15 13H17V11H15V13Z" /></>, 'InvoiceListIcon');
export default InvoiceListIcon